// create-element.ts — createCreatureElement builds the positioned creature
// <div> for the XZ canvas. Calls renderCreatureThumbnail (sibling
// creature-thumbnail.ts, window-attached) + creatureMapTokenMediaSignature
// (sibling media-signature.ts).

import type { EncounterCreatureRow } from './types';
import { encounterCreatureField } from '../shared/array-types';
import { creatureMapTokenMediaSignature } from './media-signature';

function createCreatureElement(c: EncounterCreatureRow, x: number, z: number): HTMLElement {
    // Force full uncropped image for the tactical map (XZ Widget)
    const html = renderCreatureThumbnail(c, {
        use_picture_thumbnail: false
    });

    const temp = document.createElement('div');
    temp.innerHTML = html;

    const el = temp.firstElementChild as HTMLElement | null;

    if (!el) {
        console.error('Failed to render creature thumbnail for:', c);
        return document.createElement('div'); // empty fallback
    }

    // Set ID and position data
    const ecId = encounterCreatureField(c.encounter_creatures, 'encounter_creature_id');
    el.id = `creature_${ecId}`;
    el.dataset.x = String(x);
    el.dataset.z = String(z);
    // Seed the media sig so the first animateEntityChanges pass doesn't
    // hot-swap the inner <img>/<video> and replay :has()-driven transforms
    // (e.g. the prone rotation) on a freshly created node.
    el.dataset.ftMapTokenMediaSig = creatureMapTokenMediaSignature(c);

    return el;
}

Object.assign(window, { createCreatureElement });

export { createCreatureElement };
